import {fetchTeamUpdate, TeamWithMembers} from '@blesk-frontend/api';
import {useMutation, useQueryClient} from '@tanstack/react-query';

/**
 * This mutation hook is used to update the Team.
 */
export const useTeamUpdateMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fetchTeamUpdate,
    onSuccess(data) {
      queryClient.setQueryData<TeamWithMembers[]>(['teams'], (d) => {
        return d?.map((team) => {
          if (team.id === data.id) {
            return {
              ...team,
              ...data,
            };
          }
          return team;
        });
      });
    },
  });
};
